// extracted by mini-css-extract-plugin
module.exports = {"footer":"login_modal_footer-module__footer--2Z16r"};